@if (layout) {
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  @defer (when loadCookieConsentWrapper) {
    <app-cookie-wrapper></app-cookie-wrapper>
  }
}
